import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { pdf } from "@react-pdf/renderer";
import Swal from "sweetalert2";


import OrderPdfDocument from "./OrderPdfDocument";
import Logo from "../../utils/assets/img/Logo.png";
import LogoRosa from "../../utils/assets/img/Logo-rosa.png";

import toast from "react-hot-toast";

function moneyBRL(v) {
    return Number(v || 0).toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
    });
}

function normalizePhoneDigits(rawValue) {
    let digits = String(rawValue || "").replace(/\D/g, "");

    if (digits.startsWith("55")) {
        digits = digits.slice(2);
    }

    if (digits.length > 11) {
        digits = digits.slice(-11);
    }

    return digits;
}

function normalizeWhatsAppNumber(rawValue) {
    const digits = normalizePhoneDigits(rawValue);
    if (!digits) return "";
    return `55${digits}`;
}
function formatPhoneBR(value) {
    const digits = normalizePhoneDigits(value);

    if (!digits) return "-";

    if (digits.length <= 10) {
        return digits
            .replace(/^(\d{2})(\d)/, "($1) $2")
            .replace(/(\d{4})(\d{1,4})$/, "$1-$2");
    }

    return digits
        .replace(/^(\d{2})(\d)/, "($1) $2")
        .replace(/(\d{5})(\d{1,4})$/, "$1-$2");
}

function formatDateTime(value) {
    try {
        return new Intl.DateTimeFormat("pt-BR", {
            dateStyle: "short",
            timeStyle: "short",
        }).format(new Date(value));
    } catch {
        return "-";
    }
}

function getItemProductType(item) {
    return item?.productType || item?.chainType || "-";
}

function getCustomText(item) {
    // 1. Se tiver customText (antigo)
    if (item?.customText) return item.customText;

    // 2. Se tiver customTexts (novo)
    if (Array.isArray(item?.customTexts)) {
        return item.customTexts
            .map((c) => c?.value)
            .filter(Boolean)
            .join(" • ");
    }

    return "";
}

function normalizeCustomTexts(customTexts) {
    if (!Array.isArray(customTexts)) return [];

    return customTexts
        .map((entry) => {
            if (!entry) return null;

            if (typeof entry === "string") {
                return {
                    label: "Campo",
                    value: entry,
                };
            }

            if (typeof entry === "object") {
                return {
                    label:
                        entry.label ||
                        entry.name ||
                        entry.field ||
                        entry.key ||
                        entry.placeholder ||
                        "Campo",
                    value:
                        entry.value ||
                        entry.text ||
                        entry.content ||
                        "",
                };
            }

            return null;
        })
        .filter(Boolean)
        .filter((entry) => String(entry.value || "").trim());
}

function CopyIcon({ copied = false }) {
    if (copied) {
        return (
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path
                    d="M20 6L9 17l-5-5"
                    stroke="currentColor"
                    strokeWidth="2.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        );
    }

    return (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <rect x="9" y="9" width="10" height="10" rx="2" stroke="currentColor" strokeWidth="2" />
            <path
                d="M7 15H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v1"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
            />
        </svg>
    );
}

function SuccessIcon() {
    return (
        <div style={styles.successIcon}>
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path
                    d="M20 7L10 17l-6-6"
                    stroke="currentColor"
                    strokeWidth="2.4"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        </div>
    );
}

function formatName(name) {
    if (!name) return "";

    const lowerWords = ["de", "da", "do", "dos", "das", "e"];

    return name
        .toLowerCase()
        .split(" ")
        .filter(Boolean)
        .map((word, index) => {
            if (index !== 0 && lowerWords.includes(word)) {
                return word;
            }
            return word.charAt(0).toUpperCase() + word.slice(1);
        })
        .join(" ");
}

export default function PublicOrderSuccessPage() {
    const navigate = useNavigate();
    const location = useLocation();
    const [copied, setCopied] = useState(false);

    const [searchParams] = useSearchParams();
    const sidFromUrl = String(searchParams.get("sid") || "").trim();

    const data = location.state || {};

    const {
        orderCode = "",
        createdAt = new Date(),
        seller = {},
        customer = {},
        items = [],
        total = 0,
    } = data;




    const state = location.state || {};

    const { showSuccessModal } = state;

    const rawSellerName =
        String(seller?.display_name || seller?.nome || "").trim();

    const sellerName = rawSellerName ? formatName(rawSellerName) : null;

    const sellerText = sellerName
        ? `Agora é só falar com sua Revendedora <strong>${sellerName}</strong> para continuar o atendimento do seu pedido.`
        : `Agora é só falar com sua Revendedora para continuar o atendimento do seu pedido.`;


    useEffect(() => {
        if (!showSuccessModal) return;

        Swal.fire({
            icon: "success",
            title: "Seu pedido foi gerado com sucesso ✨",
            html: `
            <div style="text-align:center; line-height:1.55;">
                <div style="font-size:15px; color:#374151; margin-bottom:14px;">
                    Recebemos seu pedido personalizado e ele já foi registrado com sucesso.
                </div>

                <div style="
                    margin: 0 auto 14px;
                    max-width: 320px;
                    background: linear-gradient(135deg, rgba(144,35,72,0.07), rgba(181,61,103,0.10));
                    border: 1px solid rgba(144,35,72,0.16);
                    border-radius: 14px;
                    padding: 12px 14px;
                ">
                    <div style="
                        font-size: 11px;
                        letter-spacing: .08em;
                        text-transform: uppercase;
                        font-weight: 800;
                        color: #902348;
                        margin-bottom: 6px;
                    ">
                        Código do pedido
                    </div>

                    <div style="
                        font-size: 22px;
                        font-weight: 900;
                        color: #902348;
                        word-break: break-word;
                    ">
                        ${orderCode || "-"}
                    </div>
                </div>
                <div style="font-size:14px; color:#4B5563;">
                    ${sellerText}
                </div>
            </div>
        `,
            confirmButtonText: "Gerar PDF",
            confirmButtonColor: "#902348",
        }).then(() => {
            navigate(location.pathname + location.search, {
                replace: true,
                state: {
                    ...state,
                    showSuccessModal: false,
                },
            });
        });
    }, [
        showSuccessModal,
        orderCode,
        navigate,
        location.pathname,
        location.search,
        state,
        sellerText
    ]);

    useEffect(() => {
        document.documentElement.classList.add("public-personalized-html");
        document.body.classList.add("public-personalized-body");

        return () => {
            document.documentElement.classList.remove("public-personalized-html");
            document.body.classList.remove("public-personalized-body");
        };
    }, []);

    async function handleCopyOrderCode() {
        try {
            await navigator.clipboard.writeText(orderCode || "");
            setCopied(true);
            toast.success("Código copiado!", {
                position: "top-center",
            });

            setTimeout(() => {
                setCopied(false);
            }, 2500);
        } catch (error) {
            console.log("Erro ao copiar código:", error);
        }
    }

    async function handleDownloadPdf() {
        const pdfDoc = (
            <OrderPdfDocument
                company={{
                    name: "Pitaya",
                    subtitle: "Joias personalizadas",
                    phone: "(51) 99870-3296",
                    website: "www.pitayajoias.com.br/",
                }}
                seller={seller}
                customer={customer}
                items={items}
                total={total}
                orderCode={orderCode}
                createdAt={createdAt}
                logoSrc={LogoRosa}
            />
        );

        try {
            const blob = await pdf(pdfDoc).toBlob();
            const pdfUrl = URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = pdfUrl;
            link.download = `${orderCode}.pdf`;
            link.click();

            setTimeout(() => URL.revokeObjectURL(pdfUrl), 10000);
        } catch (error) {
            console.log("Erro ao gerar PDF:", error);
        }
    }

    function handleSendWhatsApp() {
        const normalizedPhone = normalizeWhatsAppNumber(seller?.whatsapp);
        if (!normalizedPhone) return;

        const message = encodeURIComponent(
            `Olá! Meu pedido foi gerado com sucesso.\nCódigo: ${orderCode}\nVou enviar o PDF em anexo.`
        );

        window.open(
            `https://wa.me/${normalizedPhone}?text=${message}`,
            "_blank",
            "noopener,noreferrer"
        );
    }

    return (
        <div style={styles.page}>
            <div style={styles.wrapper}>
                <div style={styles.hero}>
                    <div style={styles.heroTop}>
                        <div style={styles.heroTextWrap}>
                            <div style={{ display: "flex", alignItems: "center", gap: "12px", width: "100%" }}>
                                <SuccessIcon />
                            </div>

                            <div style={styles.heroHeaderRow}>
                                <div style={styles.heroTitle}>
                                    Seu pedido está pronto
                                </div>
                            </div>

                            <div style={styles.heroSub}>
                                Agora é só baixar o PDF e enviar para a sua Revendedora.
                            </div>
                        </div>

                        <div style={styles.heroLogoWrap}>
                            <img src={Logo} alt="Pitaya" style={styles.heroLogo} />
                        </div>
                    </div>
                </div>

                <div style={styles.mainCard}>
                    <div style={styles.topGrid}>
                        <div style={styles.codeBox}>
                            <div style={styles.codeLabel}>Código do pedido</div>

                            <div style={styles.codeRow}>
                                <div style={styles.codeValue}>{orderCode || "-"}</div>

                                <button
                                    type="button"
                                    onClick={handleCopyOrderCode}
                                    style={styles.copyBtn}
                                    title="Copiar código"
                                >
                                    <CopyIcon copied={copied} />
                                </button>
                            </div>

                            <div style={styles.codeHint}>
                                Use esse código para consultar o pedido com a sua Revendedora.
                            </div>
                        </div>

                        <div style={styles.stepsBox}>
                            <div style={styles.stepsTitle}>Próximos passos</div>

                            <div style={styles.stepItem}>
                                <span style={styles.stepNumber}>1</span>
                                <span>Baixe o PDF do pedido</span>
                            </div>

                            <div style={styles.stepItem}>
                                <span style={styles.stepNumber}>2</span>
                                <span>Abra o WhatsApp da Revendedora</span>
                            </div>

                            <div style={styles.stepItem}>
                                <span style={styles.stepNumber}>3</span>
                                <span>Anexe o PDF na conversa</span>
                            </div>
                        </div>
                    </div>

                    <div style={styles.summaryCard}>
                        <div style={styles.sectionTitle}>Resumo do pedido</div>

                        <div style={styles.summaryGrid}>
                            <div style={styles.summaryMiniCard}>
                                <div style={styles.summaryLabel}>Cliente</div>
                                <div style={styles.summaryValue}>{customer?.name || "-"}</div>
                                <div style={styles.summarySub}>{formatPhoneBR(customer?.phone)}</div>
                            </div>

                            <div style={styles.summaryMiniCard}>
                                <div style={styles.summaryLabel}>Revendedora</div>
                                <div style={styles.summaryValue}>{seller?.display_name || "-"}</div>
                                <div style={styles.summarySub}>{formatPhoneBR(seller?.whatsapp)}</div>
                            </div>

                            <div style={styles.summaryMiniCard}>
                                <div style={styles.summaryLabel}>Gerado em</div>
                                <div style={styles.summaryValue}>{formatDateTime(createdAt)}</div>
                                <div style={styles.summarySub}>{items.length} item(ns)</div>
                            </div>

                            <div style={styles.summaryMiniCardTotal}>
                                <div style={styles.summaryLabelTotal}>Total</div>
                                <div style={styles.totalValue}>{moneyBRL(total)}</div>
                            </div>
                        </div>
                    </div>
                    <div style={styles.summaryCard}>
                        <div style={styles.summaryDateDelvery}>
                            <b style={{ color: 'black' }}>Prazo:</b> Produto estará pronto em até 35 dias corridos da confirmação do seu pedido.
                        </div>
                    </div>

                    <div style={styles.itemsCard}>
                        <div style={styles.sectionTitle}>Itens do pedido</div>

                        {!items.length ? (
                            <div style={styles.empty}>Nenhum item encontrado.</div>
                        ) : (
                            <div style={styles.itemsList}>
                                {items.map((item, index) => (
                                    <div key={`${item.optionId}-${index}`} style={styles.itemRow}>
                                        {!!item.photoUrl && (
                                            <a
                                                href={item.photoUrl}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                style={styles.itemPhotoLink}
                                                title="Abrir foto enviada"
                                            >
                                                <img
                                                    src={item.photoUrl}
                                                    alt={item.photoName || item.productName || "Foto enviada"}
                                                    style={styles.itemPhoto}
                                                />
                                            </a>
                                        )}

                                        <div style={{ flex: 1, minWidth: 0 }}>
                                            <div style={styles.itemName}>{item.productName || "-"}</div>

                                            {!!item.description && (
                                                <div style={styles.itemDescription}>
                                                    {item.description}
                                                </div>
                                            )}

                                            {(() => {
                                                const customFields = normalizeCustomTexts(item?.customTexts);

                                                if (customFields.length) {
                                                    return (
                                                        <div style={styles.itemCustomWrap}>
                                                            <div style={styles.itemCustomTitle}>Campos personalizados</div>
                                                            {customFields.map((entry, idx) => (
                                                                <div key={`${entry.label}-${idx}`} style={styles.itemCustom}>
                                                                    <strong>{entry.label}:</strong> {entry.value}
                                                                </div>
                                                            ))}
                                                        </div>
                                                    );
                                                }

                                                if (item?.customText) {
                                                    return (
                                                        <div style={styles.itemCustom}>
                                                            Personalização: {item.customText}
                                                        </div>
                                                    );
                                                }

                                                return null;
                                            })()}

                                            <div style={styles.itemMeta}>
                                                {getItemProductType(item)} • {item.color || "-"}
                                            </div>

                                            <div style={styles.itemCode}>
                                                {item.code || "-"} • Qtd {item.quantity || 1}
                                            </div>

                                            {!!item.photoUrl && (
                                                <div style={styles.itemPhotoHint}>
                                                    Foto enviada
                                                </div>
                                            )}
                                        </div>

                                        <div style={styles.itemPrice}>
                                            {moneyBRL((item.price || 0) * (item.quantity || 1))}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>

                    <div style={styles.actions}>
                        <button style={styles.primaryBtn} onClick={handleDownloadPdf}>
                            Baixar PDF
                        </button>
                    </div>

                    <button
                        style={styles.backBtn}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.background = "rgba(17,24,39,0.08)";
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.background = "rgba(17,24,39,0.04)";
                        }}
                        onClick={() =>
                            navigate(
                                `/produtos-personalizados${sidFromUrl ? `?sid=${sidFromUrl}` : ""}`
                            )
                        }
                    >
                        ← Voltar ao catálogo
                    </button>
                </div>
            </div>
        </div>
    );
}

const styles = {
    page: {
        minHeight: "100vh",
        padding: 20,
        background: "linear-gradient(180deg, rgba(144,35,72,0.08), #f6f7fb 220px)",
        boxSizing: "border-box",
        display: "flex",
        justifyContent: "center",
        width: "100%",
    },

    wrapper: {
        width: "100%",
        maxWidth: 920,
        margin: "0 auto",
        display: "grid",
        gap: 16,
        alignContent: "start",
    },

    hero: {
        padding: 22,
        borderRadius: 22,
        background: "linear-gradient(135deg, #902348 0%, #b53d67 100%)",
        color: "#fff",
        boxShadow: "0 14px 34px rgba(144,35,72,0.20)",
    },

    heroTop: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 16,
        flexWrap: "wrap",
    },

    heroTextWrap: {
        flex: 1,
        minWidth: 240,
    },

    heroLogoWrap: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minWidth: 120,
    },

    heroLogo: {
        width: "clamp(120px, 18vw, 180px)",
        maxWidth: "100%",
        height: "auto",
        objectFit: "contain",
        filter: "drop-shadow(0 6px 16px rgba(0,0,0,0.18))",
    },

    heroBadge: {
        display: "inline-flex",
        padding: "6px 10px",
        borderRadius: 999,
        background: "rgba(255,255,255,0.14)",
        fontWeight: 800,
        fontSize: 12,
    },

    heroHeaderRow: {
        marginTop: 12,
        display: "flex",
        alignItems: "center",
        gap: 12,
        flexWrap: "wrap",
    },

    successIcon: {
        width: 44,
        height: 44,
        borderRadius: 999,
        background: "rgba(255,255,255,0.16)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#fff",
        flexShrink: 0,
    },

    heroTitle: {
        fontSize: "clamp(28px, 5vw, 34px)",
        fontWeight: 900,
        lineHeight: 1.05,
    },

    heroSub: {
        marginTop: 10,
        fontSize: 15,
        lineHeight: 1.5,
        maxWidth: 620,
        opacity: 0.96,
    },

    mainCard: {
        background: "#fff",
        borderRadius: 22,
        padding: 22,
        border: "1px solid rgba(17,24,39,0.08)",
        boxShadow: "0 14px 36px rgba(0,0,0,0.08)",
        display: "grid",
        gap: 18,
    },

    topGrid: {
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
        gap: 16,
    },

    codeBox: {
        padding: 18,
        borderRadius: 18,
        background: "#F9FAFB",
        border: "1px solid rgba(17,24,39,0.06)",
    },

    codeLabel: {
        fontSize: 12,
        fontWeight: 800,
        color: "#6b7280",
        textTransform: "uppercase",
    },

    codeRow: {
        marginTop: 8,
        display: "flex",
        alignItems: "center",
        gap: 10,
    },

    codeValue: {
        fontSize: "clamp(16px, 3.6vw, 24px)",
        fontWeight: 900,
        color: "#902348",
        letterSpacing: 0.6,
        wordBreak: "break-word",
        lineHeight: 1.2,
        flex: 1,
        minWidth: 0,
    },

    copyBtn: {
        width: 36,
        height: 36,
        borderRadius: 10,
        border: "1px solid rgba(144,35,72,0.14)",
        background: "#fff",
        color: "#902348",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        flexShrink: 0,
    },

    codeHint: {
        marginTop: 8,
        fontSize: 12,
        color: "#6b7280",
        lineHeight: 1.4,
    },

    stepsBox: {
        padding: 18,
        borderRadius: 18,
        background: "rgba(144,35,72,0.04)",
        border: "1px solid rgba(144,35,72,0.10)",
    },

    stepsTitle: {
        fontSize: 15,
        fontWeight: 900,
        color: "#111827",
        marginBottom: 10,
    },

    stepItem: {
        display: "flex",
        alignItems: "center",
        gap: 10,
        fontSize: 14,
        color: "#374151",
        marginTop: 10,
    },

    stepNumber: {
        width: 24,
        height: 24,
        borderRadius: 999,
        background: "#902348",
        color: "#fff",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: 12,
        fontWeight: 900,
        flexShrink: 0,
    },

    summaryCard: {
        display: "grid",
        gap: 12,
    },

    sectionTitle: {
        fontSize: 18,
        fontWeight: 900,
        color: "#111827",
    },

    summaryGrid: {
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))",
        gap: 12,
    },

    summaryMiniCard: {
        padding: 14,
        borderRadius: 16,
        background: "#FAFAFA",
        border: "1px solid rgba(17,24,39,0.06)",
    },

    summaryMiniCardTotal: {
        padding: 14,
        borderRadius: 16,
        background: "linear-gradient(135deg, rgba(144,35,72,0.08) 0%, rgba(181,61,103,0.12) 100%)",
        border: "1px solid rgba(144,35,72,0.12)",
    },

    summaryLabel: {
        fontSize: 11,
        fontWeight: 800,
        color: "#6b7280",
        textTransform: "uppercase",
    },

    summaryLabelTotal: {
        fontSize: 11,
        fontWeight: 800,
        color: "#902348",
        textTransform: "uppercase",
    },

    summaryValue: {
        marginTop: 6,
        fontSize: 15,
        fontWeight: 900,
        color: "#111827",
        lineHeight: 1.3,
        wordBreak: "break-word",
    },

    summarySub: {
        marginTop: 4,
        fontSize: 12,
        color: "#6b7280",
        lineHeight: 1.4,
        wordBreak: "break-word",
    },

    totalValue: {
        marginTop: 8,
        fontSize: "clamp(20px, 4vw, 28px)",
        fontWeight: 900,
        color: "#902348",
        lineHeight: 1.1,
    },

    itemsCard: {
        display: "grid",
        gap: 12,
    },

    empty: {
        padding: 14,
        borderRadius: 14,
        background: "#FAFAFA",
        color: "#6b7280",
        fontWeight: 700,
    },

    itemsList: {
        display: "grid",
        gap: 10,
    },

    itemRow: {
        display: "flex",
        justifyContent: "space-between",
        gap: 12,
        padding: 14,
        borderRadius: 16,
        background: "#FAFAFA",
        border: "1px solid rgba(17,24,39,0.06)",
        alignItems: "flex-start",
    },

    itemName: {
        fontSize: 14,
        fontWeight: 900,
        color: "#111827",
    },

    itemDescription: {
        marginTop: 4,
        fontSize: 12,
        color: "#6b7280",
        lineHeight: 1.45,
        fontWeight: 600,
    },

    itemCustom: {
        fontSize: 12,
        color: "#902348",
        fontWeight: 700,
        lineHeight: 1.45,
    },

    itemMeta: {
        marginTop: 4,
        fontSize: 12,
        color: "#4b5563",
        fontWeight: 700,
    },

    itemCode: {
        marginTop: 4,
        fontSize: 12,
        color: "#8b95a1",
        fontWeight: 700,
    },

    itemPrice: {
        fontSize: 14,
        fontWeight: 900,
        color: "#111827",
        whiteSpace: "nowrap",
        alignSelf: "center",
    },

    actions: {
        display: "flex",
        gap: 12,
        flexWrap: "wrap",
        marginTop: 6,
    },

    primaryBtn: {
        flex: 1,
        minWidth: 220,
        border: "none",
        borderRadius: 12,
        padding: "14px 16px",
        background: "#902348",
        color: "#fff",
        fontWeight: 900,
        cursor: "pointer",
    },

    secondaryBtn: {
        flex: 1,
        minWidth: 220,
        border: "1px solid rgba(17,24,39,0.12)",
        borderRadius: 12,
        padding: "14px 16px",
        background: "green",
        color: "white",
        fontWeight: 900,
        cursor: "pointer",
    },

    backBtn: {
        marginTop: 12,
        background: "rgba(144,35,72,0.06)",
        border: "1px solid rgba(144,35,72,0.18)",
        color: "#902348",
        fontWeight: 900,
        cursor: "pointer",
        padding: "10px 16px",
        borderRadius: 10,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 6,
        transition: "all 160ms ease",
    },
    itemPhotoLink: {
        width: 68,
        height: 68,
        borderRadius: 12,
        overflow: "hidden",
        flexShrink: 0,
        display: "block",
        border: "1px solid rgba(17,24,39,0.08)",
        background: "#fff",
    },

    itemPhoto: {
        width: "100%",
        height: "100%",
        objectFit: "cover",
        display: "block",
    },

    itemPhotoHint: {
        marginTop: 6,
        fontSize: 11,
        color: "#6b7280",
        fontWeight: 700,
    },
    summaryDateDelvery: {
        color: 'grey',
        fontWeight: 'bold',
        textStyle: 'italic'
    },
    itemCustomWrap: {
        marginTop: 6,
        display: "grid",
        gap: 4,
    },

    itemCustomTitle: {
        fontSize: 12,
        color: "#6b7280",
        fontWeight: 800,
    },

};